import React from 'react';

function TutorialOverlay({ t }) {
  return (
    <>
      <h2 id="overlay-heading" className="about-title">{t('tutorial_title')}</h2>
      <div className="overlay-article">
        <article className="article-content">
          <p className="article-intro">{t('tutorial_intro')}</p>
          <section>
            <h3>{t('tutorial_section_one_title')}</h3>
            <p>{t('tutorial_section_one_body')}</p>
          </section>
          <section>
            <h3>{t('tutorial_section_two_title')}</h3>
            <p>{t('tutorial_section_two_body')}</p>
          </section>
          <section>
            <h3>{t('tutorial_section_three_title')}</h3>
            <p>{t('tutorial_section_three_body')}</p>
          </section>
        </article>
      </div>
    </>
  );
}

export default TutorialOverlay;
